import React from 'react';
import styled from 'styled-components'
import Loader from '../../Components/Loader';
import NormalText from '../../Components/NormalText';
import Helmet from 'react-helmet'
import Avatar from '../../Components/Avatar';
import { media } from '../../styles/Mixin';
import {Link} from 'react-router-dom'
import { NormalBorderBox } from '../../Components/NormalBorderBox';

export default({
    data,
    loading,
    channelId
})=>{
    if(loading){
        return(
            <>
            <Helmet>
                <title>로딩중..</title>
            </Helmet>
            <Loader />
            </>
        )
    }else if(data.seeUser === null){
        return(
            <Wrapper>
                <Helmet>
                    <title>존재하지 않는 채널</title>
                </Helmet>
                <NoUser>
                    <NormalText text={"채널이 존재하지 않습니다 😅"}/>
                </NoUser>
            </Wrapper>
        )
    }
    return (
      <Wrapper>
        <Helmet>
          <title>{data.seeUser.displayName} 님 채널</title>
        </Helmet>
        <BixBox>
          <GuidBox>
            <GuidNameText
              text={"'" + data.seeUser.displayName + "'"}
            ></GuidNameText>
            <GuidText text={"님의 채널에 오신걸 환영합니다!"}></GuidText>
            <AvatarBox>
              <Avatar size={"l_md"} url={data.seeUser.profileImageUrl} />
            </AvatarBox>
          </GuidBox>
          <KindBox>
            <VisitQnaBox to={`/qna/${channelId}`}>
              <NormalBorderBox text={data.seeUser.displayName + "님의 질문과 답 구경가기!"} number={data.seeUser.categoryCount}/>
            </VisitQnaBox>
          </KindBox>
        </BixBox>
      </Wrapper>
    );
}

const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    min-height:30vh;
    width:100%;
`

const NoUser = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`

const BixBox = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    align-items:center;
`


const GuidBox = styled.div`
  display: flex;
  position:relative;
  align-items: center;
  justify-content:center;
  
  ${media.deskTop`
    padding:10px;
    min-width: 70%;
    max-width: 70%;
    `}
    ${media.mobile`
    padding:2px;
    width: 80%;
    `}
    margin-bottom:30px;
    background-color: ${(props) => props.theme.blueColor};
    border-radius: 100px 100px 100px 100px;
`;
const GuidNameText = styled(NormalText)`
  font-weight: bold;
  ${media.deskTop`
    margin-left:50px;
    `}
`;

const GuidText = styled(NormalText)`
    color:${props => props.theme.grey};
`

const AvatarBox = styled.div`
  position: absolute;
  left:0;
`;

const KindBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width:100%;
`;

const VisitQnaBox = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px;
  text-decoration: none;
  color:inherit;
  width:100%;
`;